import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Observable } from 'rxjs';
import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';
import { MatSort, Sort } from "@angular/material/sort";
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Popups, PopupsFilters } from '../../../commons/models/popups';

@Component({
    selector: 'app-popups-list',
    templateUrl: './popups-list.component.html',
    styleUrls: ['./popups-list.component.scss']
})
export class PopupsListComponent {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    pageSizeOptions = PAGE_SIZE_OPTIONS;

    @Input() popups: Popups;
    @Input() selectedPopups: Popups[];
    @Input() defaultFilters: PopupsFilters;
    @Input() total: Observable<number>;

    @Input() displayedColumns: string[] = ["title", "content", "start_date", "end_date", "actions"]
    @Input() canAdd: boolean;
    @Input() canEdit: boolean;
    @Input() canSelect: boolean;

    @Output()
    onLoad: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
    @Output()
    onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
    @Output()
    onFilterChange: EventEmitter<PopupsFilters> = new EventEmitter<PopupsFilters>();

    @Output()
    onSelectPopups : EventEmitter<Popups> = new EventEmitter<Popups>();
    @Output()
    onAddPopups: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    onEditPopups: EventEmitter<Popups> = new EventEmitter<Popups>();
    @Output()
    onShowPopups: EventEmitter<Popups> = new EventEmitter<Popups>();
    @Output()
    onAddSelectedPopup: EventEmitter<Popups> = new EventEmitter<Popups>();
    @Output()
    onRemoveSelectedPopup: EventEmitter<Popups> = new EventEmitter<Popups>();

    get selectedItems(): boolean {
    return this.selectedPopups.length > 0;
    }

    ngAfterViewInit() {
        if (this.sort) {
            this.sort.sortChange.subscribe((sort) => {
            this.onSortChange.emit(sort);
            });
        }

        if (this.paginator) {
            this.paginator.page.subscribe((pageEvent) => {
            this.onPageChange.emit(pageEvent);
            });
        }
    }

    addPopup() {
        this.onAddPopups.emit();
    }
    
    editPopup(popups: Popups) {
        this.onEditPopups.emit(popups);
    }
    
    selectPopup(popups: Popups) {
        this.onSelectPopups.emit(popups);
    }

    removeSelectedPopup(popups: Popups) {
        this.onRemoveSelectedPopup.emit(popups)
    }

    onFilter(filters: PopupsFilters) {
        this.paginator.firstPage();
        this.onFilterChange.emit(filters);
    }

    showPopup(popups: Popups) {
        this.onShowPopups.emit(popups);
    }
}